import type { ButtonBaseProps } from '~shared/ui/atoms';

import { StyledBase } from './styles';

type Props = ButtonBaseProps;

export const ButtonSecondary = (props: Props) => <StyledBase {...props} />;
